import Modal from 'react-bootstrap/Modal'
import { useNavigate, useParams } from 'react-router-dom'

interface IModalProps {
    show: boolean
    onHide: () => void
    item: undefined | IMoneyPoolResults
    name: string | undefined
    isManager: boolean
    loanAmount?: number | undefined
    moneyPool?: string | undefined
    trustState?: string | undefined
    isLoan?: boolean
    selectedInstallment?: number | undefined
}
const PayToOtherModal = ({
    show,
    onHide,
    item,
    name,
    isManager,
    loanAmount,
    moneyPool,
    trustState,
    isLoan,
    selectedInstallment,
}: IModalProps) => {
    const navigate = useNavigate()
    const { id, loanId } = useParams()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" p-2 text-center">
                {isLoan ? (
                    <p>آیا مایل به پرداخت وام </p>
                ) : (
                    <p>آیا مایل به پرداخت حق عضویت</p>
                )}
                <p>
                    {item?.member.first_name} {item?.member.last_name}
                </p>
                <p>
                    به مبلغ{' '}
                    {loanAmount
                        ? loanAmount.toLocaleString()
                        : item?.unpaid_portion &&
                          item?.unpaid_portion.toLocaleString()}{' '}
                    تومان
                </p>
                <p>هستید؟</p>
                <hr className=" my-2" />
                <p
                    className=" text-green-1"
                    onClick={() => {
                        loanAmount
                            ? item &&
                              navigate(
                                  `/easy-pay/pay-for-other-in-loan/${moneyPool}`,
                                  {
                                      state: {
                                          item: {
                                              id: item.id,
                                              unpaid_portion:
                                                  loanAmount ||
                                                  item.unpaid_portion,
                                          },
                                          name,
                                          isManager,
                                          trustState,
                                          selectedInstallment,
                                          loanId,
                                      },
                                  }
                              )
                            : navigate(`/easy-pay/pay-for-other/${id}`, {
                                  state: { item, name, isManager, trustState },
                              })
                        onHide()
                    }}
                >
                    تایید
                </p>
                <hr className=" my-2" />
                <p onClick={onHide}>بستن</p>
            </div>
        </Modal>
    )
}

export default PayToOtherModal
